import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { baseurl } from "../../component/Baseurl";
import Sidebar from "./AdminComp/Sidebar";
import BreadCrumb from "./AdminComp/BreadCrumb";
import Swal from "sweetalert2";



function BookingEnquiryEdit() {
  const { id } = useParams(); // Get booking ID from URL
  const navigate = useNavigate();
  const [status, setStatus] = useState("");
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // Fetch booking details
  useEffect(() => {
    const fetchBookingDetails = async () => {
      try {
        const response = await axios.get(`${baseurl}GetBookingStatusAndNote/${id}`);
        setStatus(response.data.booking.status);
        setNote(response.data.booking.note || ""); // Handle null notes
      } catch (err) {
        setError("Error fetching booking details. Please try again.");
      } finally {
        setLoading(false);
      }
    };

    fetchBookingDetails();
  }, [id]);

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
  
    // Log the data before sending
    console.log("Sending data to the backend:", { status, note });
  
    try {
      await axios.put(`${baseurl}UpdateBookingStatusAndNote/${id}`, { status, note });
  
      // Show success alert
      Swal.fire({
        icon: "success",
        title: "Success!",
        text: "Booking updated successfully!",
        confirmButtonText: "OK",
      }).then(() => {
        navigate("/booking-enquiry"); // Redirect to booking list
      });
    } catch (err) {
      setError("Error updating booking. Please try again.");
  
      // Show error alert
      Swal.fire({
        icon: "error",
        title: "Error!",
        text: "Failed to update booking. Please try again.",
        confirmButtonText: "OK",
      });
    }
  };
  

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <BreadCrumb />
          <div className="container-fluid">
            <div className="crdmain mb-2">
              <h2 className="chart-title text-start">Edit Booking</h2>

              {/* Show Loading or Error Message */}
              {loading ? (
                <p>Loading...</p>
              ) : error ? (
                <p className="text-danger">{error}</p>
              ) : (
                <form onSubmit={handleSubmit} className="text-start">
                  <div className="mb-3">
                    <label className="form-label">Status</label>
                    <select className="form-control" value={status} onChange={(e) => setStatus(e.target.value)}>
                      <option value="Active">Active</option>
                      <option value="Pending">Pending</option>
                      <option value="Close">Close</option>
                    </select>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Note</label>
                    <textarea
                      className="form-control"
                      value={note}
                      onChange={(e) => setNote(e.target.value)}
                      placeholder="Enter notes (optional)"
                    ></textarea>
                  </div>

                  <button type="submit" className="btn btn-primary">Update</button>
                </form>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default BookingEnquiryEdit;
